import React, { createContext, useState, useContext, useCallback } from 'react';

const AlertModalContext = createContext();

export const AlertModalProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    show: false,
    title: '',
    message: '',
    variant: 'info', // 'info', 'success', 'warning', 'danger'
    onClose: null, // Callback opcional ao fechar
  });

  const showAlertModal = useCallback((title, message, variant = 'info', onCloseCallback = null) => {
    setModalState({
      show: true,
      title,
      message,
      variant,
      onClose: onCloseCallback,
    });
  }, []);

  const hideAlertModal = useCallback(() => {
    if (modalState.onClose) {
      modalState.onClose();
    }
    setModalState(prev => ({ ...prev, show: false, title: '', message: '', variant: 'info', onClose: null })); // Limpa mais estados
  }, [modalState]);

  return (
    <AlertModalContext.Provider value={{ modalState, showAlertModal, hideAlertModal }}>
      {children}
    </AlertModalContext.Provider>
  );
};

export const useAlertModal = () => {
  return useContext(AlertModalContext);
};